<div class='not-found'>
  <i class="nf-icon" [ngClass]="icon"></i>
  <span class='nf-title'>{{title}}</span>
  <span class='nf-sub-title'>{{subTitle}}</span>
</div>
